import { createColumnHelper } from '@tanstack/react-table'

import { Badge, Tooltip } from '@chakra-ui/react'

import { CSV_UploadStatus } from './csvParser'
import { ParsedDeviceI } from './csvValidator'

const columnHelper = createColumnHelper<ParsedDeviceI>()

const getBadgeColor = (status: CSV_UploadStatus) => {
  switch (status) {
    case CSV_UploadStatus.Success:
      return 'incident.resolved.100'
    case CSV_UploadStatus.Failed:
      return 'incident.active.100'
    default:
      return '#888888'
  }
}

export const createColumns = () => [
  columnHelper.accessor('uploadStatus', {
    header: 'Upload Status',
    cell: (info) => {
      const status = info.getValue() || CSV_UploadStatus.Ready
      const error = info.row.original.uploadError

      const badge = (
        <Badge bgColor={getBadgeColor(status)} color='#fff' px='2' rounded='md'>
          {status}
        </Badge>
      )

      if (status === CSV_UploadStatus.Failed && error) {
        return (
          <Tooltip label={error} placement='top'>
            {badge}
          </Tooltip>
        )
      }
      return badge
    },
  }),
  columnHelper.accessor('name', {
    header: 'Name',
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('deviceType', {
    header: 'Device Type',
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('facilityName', {
    header: 'Facility',
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('floorName', {
    header: 'Floor',
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('label', {
    header: 'Label',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('externalId', {
    header: 'External ID',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('alarmTypeName', {
    header: 'Alarm Type',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('ip', {
    header: 'IP',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('macAddress', {
    header: 'MAC Address',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('rtspPath', {
    header: 'RTSP Path',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('rtspPort', {
    header: 'RTSP Port',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('streamProtocol', {
    header: 'Stream Protocol',
    cell: (info) => info.getValue() ?? '—',
  }),
  columnHelper.accessor('streamType', {
    header: 'Stream Type',
    cell: (info) => info.getValue() ?? '—',
  }),
]
